import { render, staticRenderFns } from "./VMultiUpload.vue?vue&type=template&id=5df7ff43&"
import script from "./VMultiUpload.vue?vue&type=script&lang=js&"
export * from "./VMultiUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports